import React, { useEffect, useRef, useState } from 'react'

export interface LazyImage {
  failSrc: string
  src: string
  alt?: string
}
export function LazyImage({ src, failSrc, alt }: LazyImage) {
  const imgRef = useRef<HTMLImageElement>(null)
  const [err, setErr] = useState('')
  useEffect(() => {
    if (err && imgRef.current) {
      imgRef.current.src = failSrc
      setTimeout(() => {
        if (imgRef.current) {
          imgRef.current.src = err
          setErr('')
        }
      }, 8000)
    }
  }, [err, imgRef, failSrc])

  return (
    <img
      loading='lazy'
      ref={imgRef}
      src={src}
      alt={alt}
      onError={() => {
        setErr(src)
      }}
    />
  )
}
